import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;
const BASE = `${REACT_APP_REST_ENDPOINT}/ispezioni`;

const IspettoriService = {
  // Admin — enti
  findEnti(params) {
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, `${BASE}/enti/find`, params);
    });
  },
  indexEnti() {
    return new Promise((resolve, reject) => {
      ApiService.getRequest(resolve, reject, `${BASE}/enti/index`);
    });
  },
  createEnte(data) {
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, `${BASE}/enti/create`, data);
    });
  },
  updateEnte(data) {
    return new Promise((resolve, reject) => {
      ApiService.putRequest(resolve, reject, `${BASE}/enti/update`, data);
    });
  },
  deleteEnte(id_ente_ispettivo) {
    return new Promise((resolve, reject) => {
      ApiService.delete(resolve, reject, `${BASE}/enti/delete`, { id_ente_ispettivo });
    });
  },

  // Admin — ispettori
  findIspettori(params) {
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, `${BASE}/ispettori/find`, params);
    });
  },
  createIspettore(data) {
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, `${BASE}/ispettori/create`, data);
    });
  },
  updateIspettore(data) {
    return new Promise((resolve, reject) => {
      ApiService.putRequest(resolve, reject, `${BASE}/ispettori/update`, data);
    });
  },

  // Admin — corsi
  findCorsiByIspettore(id_utente) {
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, `${BASE}/corsi/find-by-ispettore`, { id_utente });
    });
  },
  assegnaCorsi(data) {
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, `${BASE}/corsi/assegna`, data);
    });
  },
  rimuoviCorso(id_utente, id_corso) {
    return new Promise((resolve, reject) => {
      ApiService.delete(resolve, reject, `${BASE}/corsi/rimuovi`, { id_utente, id_corso });
    });
  },

  // Admin — log
  findAccessLog(params) {
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, `${BASE}/access-log/find`, params);
    });
  },

  // Ispettore
  mieCorsi() {
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, `${BASE}/mie-corsi`, {});
    });
  },
  corsistiByCorso(id_corso) {
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, `${BASE}/corsisti-by-corso`, { id_corso });
    });
  },
  anagraficaCorsista(id_corso, id_utente_corsista) {
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, `${BASE}/anagrafica-corsista`, { id_corso, id_utente_corsista });
    });
  },
  percorsoFormativo(payload) {
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, `${BASE}/percorso-formativo`, payload);
    });
  },
  downloadActivityReport(id_corso, id_utente_corsista) {
    const url = `${BASE}/activity-report`;
    return new Promise((resolve, reject) => {
      ApiService.postRequestWithDownload(resolve, reject, url, { id_corso, id_utente_corsista });
    });
  },
};

export default IspettoriService;
